module.exports = __webpack_public_path__ + "static/media/Announcement_Icon.7e74328a.png";